import { IExportProductsParams } from '@app/models/interfaces';
import Api from '@app/services/api';
import { useExportDownload } from '@app/services/hooks/useExportDownload';

export const useExportProductsQuery = () => {
  return useExportDownload<IExportProductsParams>({
    downloadPrefix: 'products',
    getFilePath: (filename) => `/products/products/exported/${filename}`,
    mutationFn: (params) => Api.products.exportProducts(params),
  });
};
